<template>
    <div class="fans" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading">
      <Header msg='我的粉丝'/>
      <div style="height:0.44rem"></div>
      <div v-if="!shownull">
        <div class="fans-item" v-for="(e, i) in pageData" :key="i">
            <div class="per-line" v-if="e.status_str !== '已流失'">
                <div class="flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center ellipsis" style="max-width: 70%;">
                      <img :src="e.avatar_url || moren" class="item-avatar"/>
                      <p class="item-name ellipsis" v-if="e.status_str == '已流失'">{{e.nickname || '-'}}</p>
                      <p class="item-name ellipsis" v-if="e.status_str != '已流失'"><i style="font-style: normal;" v-if="e.true_name">({{e.true_name}})</i>{{e.nickname || '-'}}</p>
                    </div>
                    <p class="item-lost" v-if="e.status_str === '已流失'">粉丝已流失</p>
                    <p class="item-lost" v-if="e.status_str === '已报名'" style="background:#FABF01;color:white;">已报名</p>
                </div>
            </div>
            <div class="item-msg" v-if="e.status_str !== '已流失'">
              <p class="herfPhone" v-if="e.status_str !== '已报名' && e.binding"><a :href="'tel:' + e.binding">电话号码：{{e.binding || '-'}}</a></p>
              <p v-if="e.status_str !== '已报名' && e.is_get">优惠券：{{e.is_get || '-'}}</p>
              <p v-if="e.status_str !== '已报名' && e.addtime">领取时间：{{e.addtime || '-'}}</p>
              <p v-if="e.create_time">成为粉丝时间：{{e.create_time || '-'}}</p>
              <!-- <p>查看次数：<i class="text-yellow">{{e.count || 0}}</i> 次</p> -->
            </div>
        </div>
      </div>
      <DataNull v-if="shownull"/>
      <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';
import {getFans} from '@/api';

export default {
    name: 'Fans',
    components: {
      Header,
      DataNull,
      Nomore
    },
    data() {
      return {
        page: 1, // 页数
        pageData: [], // 页面数据
        loading: true, 
        shownull: false,
        moren: require('@/assets/avatar.png'), // 默认头像
        showNoMore: false
      }
    },
    watch:{
    },
    created() {
      this.getFansList();
    },
    methods: {
      // 加载更多
      loadMore(){
        if (this.loading) return false;
        this.loading = true;
        this.page += 1;
        this.getFansList();
      },
      // 获取页面数据
      getFansList() {
        getFans({page: this.page, limit: 10}).then(res => {
          if (res.code === 0) {
            this.pageData = this.pageData.concat(res.data);
            if (res.data.length === 0) { this.shownull = true };
            if (res.data.length === 10) { this.loading = false };
            if (res.data.length !== 10 && res.data.length !== 0) { this.showNoMore = true };
            if (Number(res.totalCount) === this.pageData.length) { this.loading = true;this.showNoMore = true };
          } else {
            this.shownull = true
          }
        })
      },
      // 调用拨号功能
      callPhone(phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    }
}

</script>
<style lang='less' scoped>
.fans{
    width: 100%;
    min-height: 100vh;
    .fans-item{
        // border-top: 0.44rem solid #f6f6fa;
        background: white;
        padding: 0 0.16rem;
        margin-top: 0.1rem;
        &>:last-child{
          border: none;
        }
        .item-avatar{
            width: 0.23rem;
            height: 0.23rem;
            margin-right: 0.12rem;
            border-radius: 50%;
        }
        .item-name{
            font-size: 0.16rem;
        }
        .item-msg{
            color: #333333;
            font-size: 0.14rem;
            padding: 0.1rem 0;
            text-align: left;
            line-height: 0.25rem
        }
        .item-lost{
            width: 0.84rem;
            height: 0.24rem;
            line-height: 0.24rem;
            background: #DBDBDB;
            color: #666666;
            border-radius: 0.12rem;
        }
    }
}
.herfPhone{
  a{
    color: #333333;
  }
}
</style>